import { v4 as uuidv4 } from "uuid";
import { isMobile } from "react-device-detect";
import cardConfirmRequest from "../components/shared/models/card-confirmation-req.json";
import moment from "moment";
import { ServiceApi } from "../environment";
import * as dataService from "../services/data.service";
import { getPath } from "./url.utils.js";
import { getConfirmRequest } from "./cardconfirm.utils.js";
import { getRequestHeaders, getCardConfirmationRequestHeaders, getSwitchRequestHeaders} from "./header.utils.js";
import { getUtilityLabelByProduct, getUtilityLabelForFooter } from "./product.utils.js";

let deviceIP = "0.0.0.0";
let xForwardedFor = "0.0.0.0";

export const getUniqueID = () => {
  return uuidv4();
};

export const getParams = () => {
  const queryString = require("query-string");
  let params = queryString.parse(location.search);
  return params;
};
export const getTitleConfirmationSuccess = () => {
  let utilityLabels =getParams().language === "es" ? require("../components/resources/resources.es") : require("../components/resources/resources.en");
  document.title=utilityLabels.utilityLabel.titleNameSucess;
  return document.title;

};
export const getTitleConfirmationError = () => {
  let utilityLabels =getParams().language === "es" ? require("../components/resources/resources.es") : require("../components/resources/resources.en");
   document.title=utilityLabels.utilityLabel.titleNameError;
   return document.title;

};
export const getTitleSystemUnavailable = () => {
   let utilityLabels =getParams().language === "es" ? require("../components/resources/resources.es") : require("../components/resources/resources.en");
   document.title=utilityLabels.utilityLabel.titleNameSorry;
   return document.title;
 };
export const getTitleSessiontimeout = () => {
  let titleNameSessiontimeout =  "Confirm Card Details | Enhanced Card Activation  | Wells Fargo";
   document.title = titleNameSessiontimeout;
  return document.title;
 };
 export const getOLBTitleConfirmcard = () => {
  let utilityLabels = getParams().language === "es" ? require("../components/resources/resources.es") : require("../components/resources/resources.en");
  document.title=utilityLabels.utilityLabel.titleNameOLBConfirmcard;
  return document.title;
 };
 export const getTitleConfirmcard = () => {
  let utilityLabels = getParams().language === "es" ? require("../components/resources/resources.es") : require("../components/resources/resources.en");
  document.title=utilityLabels.utilityLabel.titleNameConfirmcard;
  return document.title;
 };
export const getLanguage = () => {
  let params = getParams();
  switch (params.language) {
    case "en":
      return "english";
    case "es":
      return "spanish";
    default:
      return "english";
  }
};

export const getPartner = () => {
    let params = getParams();
   if (params.partner !== null && params.partner !== undefined) {

       if(params.partner?.toLowerCase() ==="choice" && params.type?.toLowerCase() === "conversion"){
         return "ChoiceConv" ;
       }else if ( params.partner?.toLowerCase()==="bilt" || params.partner?.toLowerCase()==="choice" || params.partner?.toLowerCase()==="attune" || params.partner?.toLowerCase()==="biltconversion"
       || params.partner?.toLowerCase()==="onekey" || params.partner?.toLowerCase()==="onekeyplus"){
         return params.partner?.toLowerCase();
       }else {
            return "gpcc";
       }
    }else if(params.lob !== null && params.lob !== undefined && params.lob?.toLowerCase() === "business-cards") {
     return "rubicon";
    }else{
      return "gpcc";
    }
  };

export const getUserAction = () => {
  let params = getParams();
  if (params.useraction !== undefined) {
    return params.useraction;
  } else {
    return "";
  }
};

export const getQString = () => {
  let params = getParams();
  if (params.language !== undefined && params.language !== null) {
    return params.language;
  } else {
    return "en";
  }
};

export const getEntryType = () => {
  let params = getParams();
  if (params.entrypoint !== undefined) {
    return params.entrypoint.toUpperCase();
  } else if (params.entryPoint !== undefined) {
    return params.entryPoint.toUpperCase();
  } else {
    return "URL";
  }
};

export const getEntryPoint = () => {
  let params = getParams();
  if (params.entrypoint !== undefined) {
    return params.entrypoint.toUpperCase();
  } else if (params.entryPoint !== undefined) {
    return params.entryPoint.toUpperCase();
  } else {
    return "";
  }
};

export const getFlowInd = () => {
  let params = getParams();
  if (
    params.entrypoint !== undefined &&
    params.entrypoint.toUpperCase() === "QR"
  ) {
    return "Q";
  } else if (
    params.entryPoint !== undefined &&
    params.entryPoint.toUpperCase() === "QR"
  ) {
    return "Q";
  } else {
    return "U";
  }
};

export const getDeviceType = () => {
  if (isMobile) {
    return "mobile";
  } else {
    return "desktop";
  }
};

export const getDeviceIP = () => {
 deviceIP  = ServiceApi.PUBLICIP;
 if(deviceIP !== undefined){
  if (deviceIP.indexOf(",") !== -1) {
    deviceIP = deviceIP.substring(0, deviceIP.lastIndexOf(","));
  } else if (deviceIP.indexOf(":") !== -1) {
    deviceIP = deviceIP.substring(0, deviceIP.lastIndexOf(":"));
  }
  }
  return deviceIP;
};

export const getxForwardedFor = () => {
  xForwardedFor = ServiceApi.XFORWARDEDFOR;
  return xForwardedFor;
};

export const getSwitchHeader = (eventID, partner,sessionID) => {
  return getSwitchRequestHeaders({ eventID, partner, sessionID, deviceIp: getDeviceIP(),deviceType: getDeviceType()});
};

export const getCardConfirmationHeader = (eventID,sessionID) => {
  return getCardConfirmationRequestHeaders(eventID, sessionID,getDeviceIP(), getDeviceType());
};

export const getCardConfirmationRequest = (
  formData,
  sessionID,
  eventID,
  productType
) => {
return getConfirmRequest({formData,sessionID, eventID, productType, language: getLanguage(),
        flowInd: getFlowInd(),
        deviceIp: getDeviceIP(), deviceType: getDeviceType(), xForwardedFor: getxForwardedFor()});
};

export const getTrackingRequestPayload = (page, event, eventID, sessionID) => {
  const payload = {
    trackingEvent: {
      channel: "ECA",
      page: page,
      action: event,
      language:getLanguage(),
      deviceIp: getDeviceIP(),
      deviceType: getDeviceType(),
      sessionId: sessionID,
      eventId: eventID,
      eventTSP: moment.utc().format(),
      productType:'000',
      productName: getPartner().toUpperCase()
    },
  };
  return payload;
};

export const getTrackingRequestHeaders = (eventID,sessionID) => {
  return getRequestHeaders(eventID, sessionID, getDeviceIP(), getDeviceType());
};

export const trackEvent = (page, event, eventID, sessionID) => {
  dataService
    .trackEvent(page, event, eventID, sessionID)
    .then((envRes) => {})
    .catch((err) => {
      getUnknownSorry();
    });
};

export const getURLInfo = () => {
  let params = getParams()
  return getPath(params)
};

export const findUtilityLabelFromProduct = (productType, language) =>
  getUtilityLabelByProduct(productType, language);

export const findUtilityLabelFromProductForFooter = (partner, language) =>
  getUtilityLabelForFooter(partner, language);

export const trackEventsForRedirect = (page, event, sessionID, url) => {
  if (url !== null && url !== undefined) {
    window.location.replace(url);
  }
  if(sessionID !== null && sessionID !== "" && event !==null && event !== "") {
    dataService.trackEvent( page, event,  sessionID).then();
  }
};

export const trackEventsForNoredirect = (page, event, sessionID) => {
  if(sessionID !== null && sessionID !== "" && event !==null && event !== "") {
    dataService.trackEvent( page, event,  sessionID).then();
  }
};

/**
 * Escapes HTML special characters to prevent XSS attacks
 * @param {string} text - The text to escape
 * @returns {string} - The escaped text safe for HTML insertion
 */
export const escapeHtml = (text) => {
  if (text == null || text === undefined) {
    return '';
  }
  const str = String(text);
  const htmlEscapeMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '/': '&#x2F;'
  };
  return str.replace(/[&<>"'\/]/g, (char) => htmlEscapeMap[char]);
};

/**
 * Validates a URL for use in an anchor href attribute
 * @param {string} url - The URL to validate
 * @returns {string} - The safe URL or an empty string
 */
export const safeHref = (url) => {
  if (typeof url !== 'string') {
    return '';
  }

  const trimmedUrl = url.trim();
  if (trimmedUrl === '' || trimmedUrl.startsWith('//')) {
    return '';
  }

  if (
    trimmedUrl.startsWith('/') ||
    trimmedUrl.startsWith('#') ||
    trimmedUrl.startsWith('?')
  ) {
    return trimmedUrl;
  }

  const normalizedUrl = trimmedUrl.replace(/[\u0000-\u001F\u007F-\u009F\s]/g, '');
  const schemeMatch = normalizedUrl.match(/^([a-z][a-z0-9+.-]*):/i);
  const allowedSchemes = ['https', 'tel', 'mailto'];

  if (!schemeMatch || !allowedSchemes.includes(schemeMatch[1].toLowerCase())) {
    return '';
  }

  return trimmedUrl;
};

/**
 * List of trusted static resource modules that are bundled with the application.
 * These are safe to use with html-react-parser without additional sanitization.
 * 
 * SECURITY: If resource files are ever loaded from external sources (API, CDN, etc.),
 * they MUST be added to a validation/sanitization layer before parsing as HTML.
 */
const TRUSTED_RESOURCE_MODULES = new Set([
  '../components/resources/resources.en',
  '../components/resources/resources.es',
  '../components/resources/resources.rubicon',
  '../components/resources/resources.liberty',
  '../components/resources/resources.casa',
  '../components/resources/resources.common'
]);

/**
 * Safely retrieves a utility label value with XSS protection.
 * 
 * This function provides defense-in-depth against XSS attacks by:
 * 1. Validating that labels come from trusted bundled resources
 * 2. Warning if labels might come from untrusted sources in the future
 * 3. Providing a safe fallback for dynamic content
 * 
 * @param {object} utilityLabelObject - The utility label object from resource files
 * @param {string} key - The key to retrieve from the utility label
 * @param {boolean} isTrustedSource - Whether the source is a bundled static resource (default: true)
 * @returns {string} - The label value, escaped if from untrusted source
 * 
 * @example
 * // Safe usage with bundled resources
 * const label = safeGetUtilityLabel(utilityLabel, 'thankyouHeader', true);
 * parse(label); // Safe to parse
 * 
 * @example
 * // If labels ever come from API (future-proofing)
 * const label = safeGetUtilityLabel(apiResponse.labels, 'thankyouHeader', false);
 * parse(label); // Already escaped, safe to parse as text
 */
export const safeGetUtilityLabel = (utilityLabelObject, key, isTrustedSource = true) => {
  if (!utilityLabelObject || typeof utilityLabelObject !== 'object') {
    console.warn('[Security] Invalid utility label object');
    return '';
  }

  const value = utilityLabelObject[key];
  
  if (value === undefined || value === null) {
    console.warn(`[Security] Missing utility label key: ${key}`);
    return '';
  }

  // If source is not trusted (e.g., from API), escape the content
  if (!isTrustedSource) {
    console.warn(`[Security] Utility label from untrusted source, escaping: ${key}`);
    return escapeHtml(String(value));
  }

  return value;
};

/**
 * Validates that resource labels are from trusted bundled sources.
 * 
 * This function helps detect if labels are being loaded dynamically
 * (e.g., from an API) which would require additional sanitization.
 * 
 * @param {string} modulePath - The path to the resource module
 * @returns {boolean} - True if the module is a trusted bundled resource
 * 
 * SECURITY WARNING: If you need to load labels from external sources:
 * 1. DO NOT use html-react-parser on the raw content
 * 2. Use safeGetUtilityLabel() with isTrustedSource=false
 * 3. Consider using DOMPurify for additional sanitization
 * 4. Implement Content Security Policy headers
 */
export const isTrustedResourceModule = (modulePath) => {
  return TRUSTED_RESOURCE_MODULES.has(modulePath);
};

/**
 * Checks if the current label source might be from URL parameters.
 * This is a defense-in-depth check to detect potential XSS vectors.
 * 
 * @returns {boolean} - True if labels might be influenced by URL params
 */
export const isLabelSourceTainted = () => {
  const params = getParams();
  
  // Check if language or partner params could influence resource loading
  // Currently safe because we only use these to select between trusted modules
  // But this check will warn if the pattern changes
  if (params.language && !['en', 'es'].includes(params.language)) {
    console.warn('[Security] Unexpected language parameter:', params.language);
    return true;
  }
  
  if (params.partner && typeof params.partner === 'string' && params.partner.includes('..')) {
    console.warn('[Security] Suspicious partner parameter detected:', params.partner);
    return true;
  }
  
  return false;
};